import { AssetTree, TreeCategory } from "@rio-cloud/rio-uikit";
import { useState, useContext } from "react";
import BranchTree from "./AssetTree/OptionsTree/BranchTree";
import SegmentTree from "./AssetTree/OptionsTree/SegmentTree";
import ClientSupplierTree from "./AssetTree/OptionsTree/ClientSupplierTree";
import VehicleTree from "./AssetTree/OptionsTree/VehicleTree";
import DriverTree from "./AssetTree/OptionsTree/DriverTree";
import { useAppDispatch } from "@store";
import useAssetTree from "./AssetTree/useAssetTree";
import { CoreContext } from "../../providers/CoreProvider";

const BRANCH = "branch";
const SEGMENT = "segment";
const CLIENT_SUPPLIER = "client-supplier";
const VEHICLE = "vehicle";
const DRIVER = "driver";

const CustomAssetTree = () => {
  const dispatch = useAppDispatch();
  const TreeCategoryComponent = TreeCategory as React.ComponentType<any>;
  const { isUnauthorized, isLoading } = useContext(CoreContext);

  const [isOpen, setIsOpen] = useState(false);
  const [currentCategoryId, setCurrentCategoryId] = useState(BRANCH);

  const handleChangeCategories = (categoryId: string) => setCurrentCategoryId(categoryId);

  const {
    filterOptions,
    selectedBranches,
    selectedClients,
    selectedSuppliers,
    selectedSegments,
    selectedDrivers,
    selectedVehicles,
    includeNullBranch,
    includeNullSegment,
    includeNullClient,
    includeNullSupplier,
    includeNullVehicle,
    includeNullDriver,

    setSelectedVehicles,
    setSelectedDrivers,
    setSelectedSegments,
    setSelectedClients,
    setSelectedSuppliers,
    setSelectedBranches,
    setIncludeNullBranch,
    setIncludeNullSegment,
    setIncludeNullClient,
    setIncludeNullSupplier,
    setIncludeNullVehicle,
    setIncludeNullDriver,
    tags,
    assets,
  } = useAssetTree();

  if (isLoading || isUnauthorized) {
    return (
      <>
        <style>{`.TreeSidebarToggle { display: none !important; }`}</style>
        <AssetTree
          minWidth={0}
          maxWidth={350}
          currentCategoryId={currentCategoryId}
          onCategoryChange={handleChangeCategories}
          isOpen={false}
          onToggleTree={() => {}}
          useOffscreen={false}
        />
      </>
    );
  }

  return (
    <AssetTree
      minWidth={0}
      maxWidth={350}
      currentCategoryId={currentCategoryId}
      onCategoryChange={handleChangeCategories}
      isOpen={isOpen}
      onToggleTree={(open) => {
        setIsOpen(open);
      }}
      useOffscreen={false}
    >
      <TreeCategoryComponent
        key={BRANCH}
        id={BRANCH}
        label="Filial"
        icon="rioglyph-building"
        hasSelection={!!selectedBranches.length}
      >
        <BranchTree
          filterOptions={filterOptions}
          selectedBranches={selectedBranches}
          setSelectedBranches={(items) => dispatch(setSelectedBranches(items))}
          includeNullBranch={includeNullBranch}
          setIncludeNullBranch={(value) => dispatch(setIncludeNullBranch(value))}
        />
      </TreeCategoryComponent>
      <TreeCategoryComponent
        key={SEGMENT}
        id={SEGMENT}
        label="Segmento"
        icon="rioglyph-role-management"
        hasSelection={!!selectedSegments.length}
      >
        <SegmentTree
          filterOptions={filterOptions}
          selectedSegments={selectedSegments}
          setSelectedSegments={(items) => dispatch(setSelectedSegments(items))}
          includeNullSegment={includeNullSegment}
          setIncludeNullSegment={(value) => dispatch(setIncludeNullSegment(value))}
        />
      </TreeCategoryComponent>
      <TreeCategoryComponent
        key={CLIENT_SUPPLIER}
        id={CLIENT_SUPPLIER}
        label="Cliente/Fornecedor"
        icon="rioglyph-transfer"
        hasSelection={!!selectedClients.length || !!selectedSuppliers.length}
      >
        <ClientSupplierTree
          filterOptions={filterOptions}
          selectedClients={selectedClients}
          selectedSuppliers={selectedSuppliers}
          setSelectedClients={(items) => dispatch(setSelectedClients(items))}
          setSelectedSuppliers={(items) => dispatch(setSelectedSuppliers(items))}
          includeNullClient={includeNullClient}
          includeNullSupplier={includeNullSupplier}
          setIncludeNullClient={(value) => dispatch(setIncludeNullClient(value))}
          setIncludeNullSupplier={(value) => dispatch(setIncludeNullSupplier(value))}
        />
      </TreeCategoryComponent>
      <TreeCategoryComponent
        key={VEHICLE}
        id={VEHICLE}
        label="Veiculo"
        icon="rioglyph-truck"
        hasSelection={!!selectedVehicles.length}
      >
        <VehicleTree
          tags={tags}
          assets={assets}
          selectedVehicles={selectedVehicles}
          includeNullVehicle={includeNullVehicle}
          setSelectedVehicles={(items) => dispatch(setSelectedVehicles(items))}
          setIncludeNullVehicle={(value) => dispatch(setIncludeNullVehicle(value))}
        />
      </TreeCategoryComponent>
      <TreeCategoryComponent
        key={DRIVER}
        id={DRIVER}
        label="Motorista"
        icon="rioglyph-driver"
        hasSelection={!!selectedDrivers.length}
      >
        <DriverTree
          filterOptions={filterOptions}
          selectedDrivers={selectedDrivers}
          setSelectedDrivers={(items) => dispatch(setSelectedDrivers(items))}
          includeNullDriver={includeNullDriver}
          setIncludeNullDriver={(value) => dispatch(setIncludeNullDriver(value))}
        />
      </TreeCategoryComponent>
    </AssetTree>
  );
};

export default CustomAssetTree;
